// src/Components/PlayingAsRow.jsx
// "Playing as Tobi · Change": the saved name, shown wherever a room is created
// or joined, so nobody types it twice. Mirrors the mobile Home row.
import React from "react";
import { Pencil } from "lucide-react";

const PlayingAsRow = ({ name, onChange, className = "" }) => (
  <div className={`flex items-center justify-between gap-3 bg-gray-50 rounded-2xl pl-4 pr-1.5 py-1.5 ${className}`}>
    <p className="text-sm text-gray-600 min-w-0 truncate">
      Playing as <span className="font-bold text-brand-text">{name}</span>
    </p>
    <button
      type="button"
      onClick={onChange}
      className="flex items-center gap-1.5 min-h-[44px] px-3 rounded-xl text-sm font-semibold text-brand-accent hover:bg-red-50 transition-colors flex-shrink-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-brand-accent"
    >
      <Pencil size={14} aria-hidden="true" />
      Change
    </button>
  </div>
);

export default PlayingAsRow;
